module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.1.0-rc.47-198.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.1.0-rc.47.md
// module id = 641
// module chunks = 371